/**
* Returns index of response in list
* @param {Immutable.List} list - response list
* @param {String} id - response id to search for
* @returns {Number}
*/
export function getResponseIndex(list, id) {
  return list.findIndex(listItem => listItem.id === id);
}
